(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7394],{

/***/ 24627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ useCall; },
  "G": function() { return /* binding */ useCalls; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/providers/chainState/multiChainStates/context.js
var context = __webpack_require__(39183);
// EXTERNAL MODULE: ./node_modules/@ethersproject/abi/lib.esm/interface.js
var lib_esm_interface = __webpack_require__(8198);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useRawCalls.js



/**
 * A low-level function that makes multiple calls to specific methods of specific contracts and returns values or error if present.
 * The hook will cause the component to refresh when values change.
 *
 * Calls will be combined into a single multicall across all uses of {@link useChainCall}, {@link useChainCalls}, {@link useRawCall} and {@link useRawCalls}.
 * It is recommended to use {@link useCalls} where applicable instead of this method.
 * @public
 * @param calls List of calls, also see {@link RawCall}. Calls need to be in the same order across component renders.
 * @returns list of multicall calls. See {@link RawCallResult} and {@link useRawCall}.
 */
function useRawCalls(calls) {
    const { dispatchCalls, chains } = (0,react.useContext)(context/* MultiChainStatesContext */.J);
    (0,react.useEffect)(() => {
        const filteredCalls = calls.filter(Boolean);
        dispatchCalls({ type: 'ADD_CALLS', calls: filteredCalls });
        return () => dispatchCalls({ type: 'REMOVE_CALLS', calls: filteredCalls });
    }, [JSON.stringify(calls), dispatchCalls]);
    return (0,react.useMemo)(() => calls.map((call) => {
        return call ? extractCallResult(chains, call) : undefined;
    }), [JSON.stringify(calls), chains]);
}
/**
 * A low-level function that makes a call to a specific method of a specific contract and returns the value or error if present.
 * The hook will cause the component to refresh whenever a new block is mined and the value is changed.
 *
 * Calls will be combined into a single multicall across all uses of {@link useChainCall}, {@link useChainCalls}, {@link useRawCall} and {@link useRawCalls}.
 * It is recommended to use {@link useCall} where applicable instead of this method.
 *
 * @param call a single call, also see {@link RawCall}.
 *             A call can be Falsy, as it is important to keep the same ordering of hooks even if in a given render cycle
 *             and there might be not enough information to perform a call.
 * @public
 * @returns result of multicall call.
 *   The hook returns {@link RawCallResult} type.
 *   That is: `undefined` when call didn't return yet or object `{ success: boolean, value: string }` if it did,
 *   `success` - boolean indicating whether call was successful or not,
 *   `value` - encoded result when success is `true` or encoded error message when success is `false`.
 */
function useRawCall(call) {
    return useRawCalls([call])[0];
}
function extractCallResult(chains, call) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const chainId = call.chainId;
    if (chainId !== undefined) {
        const rawCallResult = (_d = (_c = (_b = (_a = chains[chainId]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.state) === null || _c === void 0 ? void 0 : _c[call.address.toLowerCase()]) === null || _d === void 0 ? void 0 : _d[call.data];
        if (rawCallResult) {
            return rawCallResult;
        }
        const error = (_f = (_e = chains[chainId]) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.error;
        if (error) {
            const defaultErrorMessage = 'An error occurred';
            const errorMessage = (_q = (_p = (_m = (_l = (_j = (_h = (_g = error.error) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : (_k = error.error) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : error.reason) !== null && _m !== void 0 ? _m : (_o = error.data) === null || _o === void 0 ? void 0 : _o.message) !== null && _p !== void 0 ? _p : error.message) !== null && _q !== void 0 ? _q : defaultErrorMessage;
            const value = new lib_esm_interface/* Interface */.vU(['function Error(string)']).encodeFunctionData('Error', [errorMessage]);
            return {
                success: false,
                value,
            };
        }
    }
}
//# sourceMappingURL=useRawCalls.js.map
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/helpers/calls.js
var helpers_calls = __webpack_require__(96997);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useChainId.js
var useChainId = __webpack_require__(93942);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useConfig.js
var useConfig = __webpack_require__(75405);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useCall.js





/**
 * Makes a call to a specific method of a specific contract and returns the value or an error if present.
 * The hook will cause the component to refresh when a new block is mined and the return value changes.
 * A syntax sugar for {@link useRawCall} that uses ABI, function name, and arguments instead of raw data.
 * If typechain contract is used in `call` parameter then method name and arguments will be type checked.
 * Result will be typed as well.
 *
 * More on type checking [here](https://usedapp-docs.netlify.app/docs/Guides/Reading/Typechain).
 *
 * @public
 * @param call a single call to a contract, also see {@link Call}
 * @returns The hook returns {@link CallResult} type.
 *
 * @example
 * function useTotalSupply(tokenAddress: string | undefined): BigNumber | undefined {
 *    const { value, error } = useCall(tokenAddress && {
 *      contract: new Contract(tokenAddress, ERC20Interface),
 *      method: 'totalSupply',
 *      args: []
 *    }) ?? {}
 *    if(error) {
 *      console.error(error.message)
 *      return undefined
 *    }
 *    return value?.[0]
 * }
 */
function useCall(call, queryParams = {}) {
    return useCalls([call], queryParams)[0];
}
/**
 * Makes calls to specific methods of specific contracts and returns values or an error if present.
 * The hook will cause the component to refresh when a new block is mined and the return values change.
 * A syntax sugar for {@link useRawCalls} that uses ABI, function name, and arguments instead of raw data.
 * @public
 * @param calls a list of contract calls, also see {@link Call}.
 * @param queryParams see {@link QueryParams}.
 * @returns a list of results (see {@link CallResult}).
 *
 * @example
 * function useTotalSupplies(tokenAddresses: string[] | undefined): (BigNumber | undefined)[] {
 *   const calls = tokenAddresses?.map(address => ({
 *     contract: new Contract(address, ERC20Interface),
 *     method: 'totalSupply',
 *     args: []
 *   })) ?? []
 *   const results = useCalls(calls) ?? []
 *   results.forEach((result, idx) => {
 *     if(result && result.error) {
 *       console.error(`Error encountered calling 'totalSupply' on ${calls[idx]?.contract.address}: ${result.error.message}`)
 *     }
 *   })
 *   return results.map(result => result?.value?.[0])
 * }
 */
function useCalls(calls, queryParams = {}) {
    const chainId = (0,useChainId/* useChainId */.x)({ queryParams });
    const { refresh } = (0,useConfig/* useConfig */.Z)();
    const potentialRawCalls = (0,react.useMemo)(() => calls.map((call) => {
        var _a;
        return chainId !== undefined
            ? (0,helpers_calls/* encodeCallData */.Mo)(call, chainId, Object.assign(Object.assign({}, queryParams), { refresh: (_a = queryParams.refresh) !== null && _a !== void 0 ? _a : refresh }))
            : undefined;
    }), [
        JSON.stringify(calls.map((call) => call && { address: call.contract.address.toLowerCase(), method: call.method, args: call.args })),
        chainId,
    ]);
    const rawCalls = (0,react.useMemo)(() => potentialRawCalls.map((potentialCall) => (potentialCall instanceof Error ? undefined : potentialCall)), [potentialRawCalls]);
    const results = useRawCalls(rawCalls);
    return (0,react.useMemo)(() => results.map((result, idx) => {
        if (potentialRawCalls[idx] instanceof Error) {
            return { value: undefined, error: potentialRawCalls[idx] };
        }
        return (0,helpers_calls/* decodeCallResult */.tX)(calls[idx], result);
    }), [results]);
}
//# sourceMappingURL=useCall.js.map

/***/ }),

/***/ 30475:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/airdrops",
      function () {
        return __webpack_require__(40771);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var EmptyContent = function EmptyContent(param) {
    var desc = param.desc, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative w-[287px] h-[217px] ".concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "100%",
                height: "100%",
                viewBox: "0 0 283 217",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M283 141.5C283 219.648 219.648 216.5 141.5 216.5C63.3517 216.5 0 219.648 0 141.5C0 63.3517 63.3517 0 141.5 0C219.648 0 283 63.3517 283 141.5Z",
                    fill: "#EEF4FC"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-full flex flex-col items-center justify-center absolute top-0 left-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "53",
                        height: "52",
                        viewBox: "0 0 53 52",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M26.5 0C21.3577 0 16.3309 1.52487 12.0552 4.38179C7.77951 7.23871 4.44702 11.2994 2.47914 16.0502C0.511265 20.8011 -0.00362134 26.0288 0.999594 31.0723C2.00281 36.1159 4.47907 40.7486 8.11524 44.3848C11.7514 48.0209 16.3842 50.4972 21.4277 51.5004C26.4712 52.5036 31.6989 51.9887 36.4498 50.0209C41.2007 48.053 45.2613 44.7205 48.1182 40.4448C50.9751 36.1691 52.5 31.1423 52.5 26C52.4868 19.1084 49.7433 12.5029 44.8702 7.62982C39.9971 2.75674 33.3916 0.0132149 26.5 0ZM17.5 24C16.9067 24 16.3266 23.8241 15.8333 23.4944C15.34 23.1648 14.9554 22.6962 14.7284 22.1481C14.5013 21.5999 14.4419 20.9967 14.5577 20.4147C14.6734 19.8328 14.9591 19.2982 15.3787 18.8787C15.7982 18.4591 16.3328 18.1734 16.9147 18.0576C17.4967 17.9419 18.0999 18.0013 18.6481 18.2284C19.1962 18.4554 19.6648 18.8399 19.9944 19.3333C20.3241 19.8266 20.5 20.4067 20.5 21C20.5 21.7956 20.1839 22.5587 19.6213 23.1213C19.0587 23.6839 18.2957 24 17.5 24ZM35.5 24C34.9067 24 34.3266 23.8241 33.8333 23.4944C33.34 23.1648 32.9554 22.6962 32.7284 22.1481C32.5013 21.5999 32.4419 20.9967 32.5577 20.4147C32.6734 19.8328 32.9591 19.2982 33.3787 18.8787C33.7982 18.4591 34.3328 18.1734 34.9147 18.0576C35.4967 17.9419 36.0999 18.0013 36.6481 18.2284C37.1962 18.4554 37.6648 18.8399 37.9944 19.3333C38.3241 19.8266 38.5 20.4067 38.5 21C38.5 21.7956 38.1839 22.5587 37.6213 23.1213C37.0587 23.6839 36.2957 24 35.5 24Z",
                            fill: "#87B5FF"
                        })
                    }),
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mt-3 text-gray1 font-normal",
                        children: desc
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyContent);


/***/ }),

/***/ 42901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_MenuLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/common/AppMenu.tsx
var AppMenu = __webpack_require__(40758);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.js + 13 modules
var Menu = __webpack_require__(88002);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Drawer/Drawer.js + 4 modules
var Drawer = __webpack_require__(92716);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/services/config.tsx
var config = __webpack_require__(35618);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
;// CONCATENATED MODULE: ./src/components/common/AppMobileMenu.tsx











var AppMobileMenu = function() {
    var ref = (0,react.useState)(false), drawerOpened = ref[0], setDrawerOpened = ref[1];
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useAccount/* default */.Z)(), login = ref1.login, logout = ref1.logout, isLogin = ref1.isLogin, address = ref1.address;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var switchNetwork = (0,dist/* useSwitchNetwork */.g0)().switchNetwork;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative z-10 h-[56px]",
        style: {
            filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "layout-content flex h-[60px] items-center justify-between px-5 md:px-14",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "action block sm:hidden",
                            onClick: function() {
                                setDrawerOpened(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/assets/burger.png",
                                width: 18,
                                height: 15
                            })
                        }),
                        isLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
                            shadow: "md",
                            position: "bottom-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "btn-pri px-6 ",
                                            children: (0,format/* trimAddr */.nM)(address, 1)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu.Dropdown */.v.Dropdown, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Label */.v.Label, {
                                            children: "Select a Network"
                                        }),
                                        AppMenu/* menus.map */.IJ.map(function(menu) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: menu.icon,
                                                    alt: "ethereum",
                                                    className: "h-4 w-4"
                                                }),
                                                onClick: function() {
                                                    // @ts-ignore
                                                    switchNetwork(menu.chain.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "font-bold",
                                                    children: [
                                                        menu.name,
                                                        (chain === null || chain === void 0 ? void 0 : chain.id) === menu.chain.id ? "(Active)" : null
                                                    ]
                                                })
                                            }, menu.name);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Label */.v.Label, {
                                            children: "Test Network"
                                        }),
                                        AppMenu/* testNetworkMenus.map */.kG.map(function(menu) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: menu.icon,
                                                    alt: "ethereum",
                                                    className: "h-4 w-4"
                                                }),
                                                onClick: function() {
                                                    // @ts-ignore
                                                    switchNetwork(menu.chain.id);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "font-bold",
                                                    children: [
                                                        menu.name,
                                                        (chain === null || chain === void 0 ? void 0 : chain.id) === menu.chain.id ? "(Active)" : null
                                                    ]
                                                })
                                            }, menu.name);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Divider */.v.Divider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                            onClick: function() {
                                                return navigator.clipboard.writeText(address || "");
                                            },
                                            children: "Copy address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                            onClick: logout,
                                            children: "Disconnect wallet"
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: "px-6",
                            onClick: login,
                            children: "Connect"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* Drawer */.d, {
                opened: drawerOpened,
                onClose: function() {
                    return setDrawerOpened(false);
                },
                padding: "xl",
                size: "sm",
                trapFocus: false,
                withCloseButton: false,
                classNames: {
                    root: "p-0",
                    body: "h-full p-0",
                    overlay: "!bg-[rgba(0,0,0,0.8)]"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full h-full flex-shrink-0 bg-dark1 px-4 py-6 flex flex-col",
                    children: [
                        [
                            (0,config/* getRoute */.B)("dashboard")
                        ].map(function(tab) {
                            var isActive = router.pathname === tab.route;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat(tab.route),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex py-3 pb-0 action",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(tab.Icon, {
                                            className: "".concat(isActive ? "fill-[#87B5FF]" : "fill-[#8F8F8F]")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2 text-sm font-semibold ".concat(isActive ? "text-white" : "text-[#8F8F8F]"),
                                            children: tab.label
                                        })
                                    ]
                                })
                            }, tab.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                            color: "#3A3A3A",
                            className: "mt-7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-4",
                            children: AppMenu/* tabs.map */.eA.map(function(tab) {
                                var isActive = router.pathname.indexOf(tab.route) === 0;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "".concat(tab.route),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex py-3 action last:pb-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tab.Icon, {
                                                className: "".concat(isActive ? "fill-[#87B5FF]" : "fill-[#8F8F8F]")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-2 text-sm font-semibold ".concat(isActive ? "text-white" : "text-[#8F8F8F]"),
                                                children: tab.label
                                            })
                                        ]
                                    })
                                }, tab.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var common_AppMobileMenu = (AppMobileMenu);

// EXTERNAL MODULE: ./node_modules/react-div-100vh/dist/esm/index.js
var esm = __webpack_require__(66409);
// EXTERNAL MODULE: ./src/form/components/common/icons.tsx
var icons = __webpack_require__(85119);
// EXTERNAL MODULE: ./src/config/config.js
var config_config = __webpack_require__(35055);
// EXTERNAL MODULE: ./src/components/common/ConnectWallet.tsx + 1 modules
var ConnectWallet = __webpack_require__(12256);
;// CONCATENATED MODULE: ./src/components/common/MenuLayout.tsx









var MenuLayout = function MenuLayout(param) {
    var children = param.children;
    var height = (0,esm/* use100vh */.g)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "overflow-hidden flex flex-col",
        style: {
            height: height ? "".concat(height, "px") : "100vh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-[60px] flex-grow-0 flex items-center justify-between backdrop-blur bg-white px-6 sm:px-[60px] text-sm",
                style: {
                    filter: "drop-shadow(15px 4px 40px rgba(0, 0, 0, 0.1))"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/airdrop_assets/karatdao4x.png",
                            width: 150,
                            height: 40,
                            className: "-translate-y-1 action"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center gap-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWallet/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "action text-primary font-semibold",
                                    children: "Exit app"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 flex flex-col sm:flex-row overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "p-3 pr-0 hidden sm:block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenu/* default */.ZP, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_AppMobileMenu, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 overflow-x-hidden",
                        children: [
                            config_config/* isMaintenance */.b6 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-3 mx-5 sm:mx-[7vw] flex items-center justify-center bg-bg_brown mb-2 font-bold rounded-lg p-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* TrumpetIcon */.Db, {
                                        className: "mr-2"
                                    }),
                                    "Server is under maintenance"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: children
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var common_MenuLayout = (MenuLayout);


/***/ }),

/***/ 40771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ airdrops; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/common/icons.tsx
var icons = __webpack_require__(58163);
// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Menu/Menu.js + 13 modules
var Menu = __webpack_require__(88002);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Divider/Divider.js + 1 modules
var Divider = __webpack_require__(54777);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./src/components/common/EmptyContent.tsx
var EmptyContent = __webpack_require__(47761);
// EXTERNAL MODULE: ./src/components/common/MenuLayout.tsx + 1 modules
var MenuLayout = __webpack_require__(42901);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useEthers.js
var useEthers = __webpack_require__(57495);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useCall.js + 1 modules
var useCall = __webpack_require__(24627);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(64146);
// EXTERNAL MODULE: ./src/chain-info/contracts/AirdropFactory.json
var AirdropFactory = __webpack_require__(65637);
// EXTERNAL MODULE: ./src/chain-info/contracts/NFTAirdropFactory.json
var NFTAirdropFactory = __webpack_require__(4651);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/addresses.js
var addresses = __webpack_require__(9279);
// EXTERNAL MODULE: ./node_modules/@ethersproject/abi/lib.esm/interface.js
var lib_esm_interface = __webpack_require__(8198);
// EXTERNAL MODULE: ./src/chain-info/map.json
var map = __webpack_require__(14765);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useMyCampaignsByType.tsx







var useMyCampaignsByType = function(campaignType, chainId) {
    var account = (0,useEthers/* useEthers */.K)().account;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)([]), campaigns = ref2[0], setCampaigns = ref2[1];
    var TokenAbi = AirdropFactory/* abi */.Mt;
    var stringChainId = String(chainId);
    var airdropFactoryAddress = chainId ? map[stringChainId]["AirdropFactory"][0] : addresses/* AddressZero */.d;
    var airdropFactoryInterface = new lib_esm_interface/* Interface */.vU(TokenAbi);
    var airdropFactoryContract = new lib_esm.Contract(airdropFactoryAddress, airdropFactoryInterface);
    var NFTAbi = NFTAirdropFactory/* abi */.Mt;
    var nftAirdropFactoryAddress = chainId ? map[stringChainId]["NFTAirdropFactory"][0] : addresses/* AddressZero */.d;
    var nftAirdropFactoryInterface = new lib_esm_interface/* Interface */.vU(NFTAbi);
    var nftAirdropFactoryContract = new lib_esm.Contract(nftAirdropFactoryAddress, nftAirdropFactoryInterface);
    var contract = campaignType === "TOKEN" ? airdropFactoryContract : nftAirdropFactoryContract;
    var ref3;
    // const value1 = contract?.interface;
    var ref4 = (ref3 = (0,useCall/* useCall */.W)(// @ts-ignore
    account && {
        contract: contract,
        method: "getCampaignsByCreator",
        args: [
            account
        ]
    }, {
        chainId: chainId
    })) !== null && ref3 !== void 0 ? ref3 : {}, value = ref4.value, callError = ref4.error;
    if (callError) {
        console.error(callError.message);
    }
    (0,react.useEffect)(function() {
        setLoading(true);
        if (value) {
            setCampaigns(value === null || value === void 0 ? void 0 : value[0]);
            setLoading(false);
        }
        if (callError) {
            setError(callError.message);
            setLoading(false);
        }
    }, [
        callError,
        value
    ]);
    return {
        campaigns: campaigns,
        error: error,
        loading: loading
    };
};
/* harmony default export */ var hooks_useMyCampaignsByType = (useMyCampaignsByType);

// EXTERNAL MODULE: ./src/airdrop/hooks/useCampaignInfo.ts
var useCampaignInfo = __webpack_require__(87655);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useMyCampaigns.tsx



var useMyCampaigns = function(chainId) {
    var ref = hooks_useMyCampaignsByType("TOKEN", chainId), tokenCampaigns = ref.campaigns, //error: campaignError,
    tokenCampaignLoading = ref.loading;
    // console.log('tokenCampaigns', tokenCampaigns);
    var ref1 = hooks_useMyCampaignsByType("NFT", chainId), nftCampaigns = ref1.campaigns, //error: campaignError,
    nftCampaignLoading = ref1.loading;
    // const campaigns = [...nftCampaigns, ...tokenCampaigns];
    var ref2 = (0,useCampaignInfo/* default */.Z)("TOKEN", tokenCampaigns, chainId), tokenCampaignInfo = ref2.campaignInfo, tokenInfoLoading = ref2.loading;
    var ref3 = (0,useCampaignInfo/* default */.Z)("NFT", nftCampaigns, chainId), nftCampaignInfo = ref3.campaignInfo, nftInfoLoading = ref3.loading;
    var loading = nftCampaignLoading || tokenCampaignLoading || tokenInfoLoading || nftInfoLoading;
    var campaigns = (0,_to_consumable_array/* default */.Z)(nftCampaignInfo).concat((0,_to_consumable_array/* default */.Z)(tokenCampaignInfo));
    return {
        campaigns: campaigns,
        loading: loading
    };
};
/* harmony default export */ var hooks_useMyCampaigns = (useMyCampaigns);

// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/airdrop/hooks/useFetchData.ts
var useFetchData = __webpack_require__(82741);
// EXTERNAL MODULE: ./src/airdrop/components/ImageProcessor.js
var ImageProcessor = __webpack_require__(97404);
// EXTERNAL MODULE: ./src/chain-info/KaratDaoSupportedChain.ts
var KaratDaoSupportedChain = __webpack_require__(93171);
;// CONCATENATED MODULE: ./src/airdrop/components/CampaignRowItem.tsx





var CampaignRowItem = function(param) {
    var campaign = param.campaign;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,useFetchData/* default */.Z)(campaign === null || campaign === void 0 ? void 0 : campaign.baseInfoURI), baseInfoURIData = ref4.data;
    var expectedChain = KaratDaoSupportedChain/* KARATDAO_DEFAULT_SUPPORTED_CHAINS.find */.f.find(function(network) {
        return network.chainId === (campaign === null || campaign === void 0 ? void 0 : campaign.chainId);
    });
    var chainName = expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainName;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/airdrops/".concat(chainName, "/").concat(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.type) === null || ref === void 0 ? void 0 : ref.toLowerCase(), "/").concat(campaign.address),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "mb-3 flex w-full flex-col items-center justify-between rounded-lg bg-bg_blue1 text-dark1 px-6 py-4 action sm:flex-row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    "data-testid": "campaign-item",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProcessor/* default */.Z, {
                                src: baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image,
                                size: "s300",
                                className: "mr-6 h-[85px] w-[85px] rounded-md object-cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-1 font-bold text-sm",
                                    children: campaign === null || campaign === void 0 ? void 0 : campaign.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-1 text-gray1 text-xs",
                                    children: [
                                        "Network: ",
                                        chainName
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-gray1 text-xs",
                                    children: [
                                        "Total Airdrop Supply: ",
                                        campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.reach) === null || ref1 === void 0 ? void 0 : ref1.toString()
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "sm::mt-0 mt-2 text-sm flex w-full justify-between sm:mr-10 sm:w-1/3 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Total Claimed"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-bold",
                                    children: campaign === null || campaign === void 0 ? void 0 : (ref2 = campaign.claimedNum) === null || ref2 === void 0 ? void 0 : ref2.toString()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Total Wallets"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "font-bold",
                                    children: campaign === null || campaign === void 0 ? void 0 : (ref3 = campaign.reach) === null || ref3 === void 0 ? void 0 : ref3.toString()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-start space-y-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "font-bold flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[5px] h-[5px] rounded-full mr-1 mt-1 ".concat((campaign === null || campaign === void 0 ? void 0 : campaign.isActive) ? "bg-[#259A08]" : "bg-[#FF5D5D]")
                                        }),
                                        (campaign === null || campaign === void 0 ? void 0 : campaign.isActive) ? "Active" : "Stopped"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_CampaignRowItem = (CampaignRowItem);

// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./src/config/config.js
var config = __webpack_require__(35055);
;// CONCATENATED MODULE: ./src/pages/dashboard/airdrops/index.tsx















var Dashboard = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,useAccount/* default */.Z)(), login = ref.login, isLogin = ref.isLogin;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var isChainSupport = map[String(chain === null || chain === void 0 ? void 0 : chain.id)];
    var ref1 = hooks_useMyCampaigns(isLogin && isChainSupport ? chain === null || chain === void 0 ? void 0 : chain.id : undefined), campaigns = ref1.campaigns, loading = ref1.loading;
    var switchNetwork = (0,dist/* useSwitchNetwork */.g0)().switchNetwork;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-5 sm:px-[7vw]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "max-w-[1100px] mx-auto mt-6 ".concat(config/* isMaintenance */.b6 ? "sm:mt-8" : "sm:mt-14", " px-5 md:px-0 flex items-center justify-between flex-wrap"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-header font-bold text-dark1",
                                    children: "Airdrops"
                                })
                            }),
                            isChainSupport && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu */.v, {
                                    trigger: "hover",
                                    classNames: {
                                        dropdown: "!w-[134px]"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Target */.v.Target, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center h-10 w-36 justify-center border-none bg-primary rounded-full ml-2 hover:cursor-pointer hover:bg-primary/80",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Add1Icon */.PZ, {
                                                        className: "fill-white w-5"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-white font-semibold ml-2",
                                                        children: "Create new"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Menu/* Menu.Dropdown */.v.Dropdown, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* RiCopperCoinLine */.cSq, {
                                                        size: 14
                                                    }),
                                                    onClick: function() {
                                                        router.push("/dashboard/airdrops/create?type=TOKEN");
                                                    },
                                                    children: "Token"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* Menu.Item */.v.Item, {
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlinePicture */.Ypm, {
                                                        size: 14
                                                    }),
                                                    onClick: function() {
                                                        router.push("/dashboard/airdrops/create?type=NFT");
                                                    },
                                                    children: "NFT"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Divider */.i, {
                        className: "border-gray2 my-6"
                    }),
                    !isChainSupport && isLogin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center w-full mt-[156px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyContent/* default */.Z, {
                                desc: "".concat(chain === null || chain === void 0 ? void 0 : chain.name, " not support")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: "mt-6",
                                onClick: function() {
                                    // @ts-ignore
                                    switchNetwork(1);
                                },
                                children: "Switch network"
                            })
                        ]
                    }),
                    isChainSupport && campaigns.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center w-full mt-[156px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyContent/* default */.Z, {
                            desc: "There’s nothing here yet"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-[1100px] mx-auto pb-10",
                        children: campaigns.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CampaignRowItem, {
                                campaign: item
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var airdrops = (Dashboard);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,3454,2280,6034,7172,2256,8517,1032,9774,2888,179], function() { return __webpack_exec__(30475); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);